import { CountryFlag } from '@/components/CountryFlag';
import type { ISO2 } from '@/constants/countries';

export type Props = {
  type: 'secondary';
  id: string;
  label: string;
  name: string;
  exchangeCountryIso: ISO2 | null;
  uniqueSymbol: string;
};

export const SecondaryListing = ({
  label,
  exchangeCountryIso,
  uniqueSymbol,
}: Props) => {
  return (
    <div
      className="flex flex-row flex-wrap content-center justify-start"
      data-cy-id={`secondary-listing-${label}`}
    >
      <div className="flex-basis-0 relative flex w-full grow flex-nowrap items-center pb-1">
        <div className="min-w-[68px]" />
        <div className="mr-1">
          <CountryFlag countryISO={exchangeCountryIso} />
        </div>
        <p className="m-0 text-tiny text-soft">{uniqueSymbol}</p>
      </div>
    </div>
  );
};
